/*
  GlowWell — hide unavailable variant options for a single product.

  Scoped narrowly: only acts when the page's <variant-picker> element has
  data-product-handle="heated-eyelash-curler", and only touches labels whose
  input carries data-option-available="false" (a real, live Shopify value,
  not a hardcoded style name). No variants are deleted, no other product is
  affected, nothing else on the page is touched.

  A CSS-only version of this fix (display:none!important on the same
  selector) did not reliably apply on this theme despite matching the
  correct elements — confirmed via direct selector testing — so this uses
  inline style application instead, which is reliably respected.
*/
(function () {
  function hideUnavailableVariants() {
    var picker = document.querySelector('variant-picker[data-product-handle="heated-eyelash-curler"]');
    if (!picker) return;
    var inputs = picker.querySelectorAll('input[data-option-available="false"]');
    inputs.forEach(function (input) {
      var label = input.closest('label');
      if (label) {
        label.style.setProperty('display', 'none', 'important');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideUnavailableVariants);
  } else {
    hideUnavailableVariants();
  }
})();
